import { LDN_CG_VENUE_ID, NY_HQ_VENUE_ID } from "../../shared/defines";

export type WaiverContentType = {
  element: string;
  className?: string;
  text: string;
  children?: WaiverContentType[];
  pdfPrefix?: string;
};

export type CheckInAgreeWaiverComponentProps = {
  onSubmit: (value: { signatureBase64: string; fullName: string }) => void;
};

export type CheckInAgreeWaiverProxyComponentProps = {
  onSubmit: (value: {
    fullName: string;
    childFullName: string;
    signatureBase64: string;
  }) => void;
  defaultFirstName: string;
  defaultLastName: string;
};

const WAIVER_CONTENT: WaiverContentType[] = [
  {
    element: "li",
    className: "font-bold",
    text: "I CONFIRM THAT NEITHER I NOR ANY MEMBER OF MY FAMILY WORKS FOR A BUSINESS THAT IS SIMILAR TO OR COMPETES WITH SPYSCAPE OR SPYGAMES",
  },
  {
    element: "li",
    text: "Age Requirement: I confirm that I am at least 18 years old. If I am under the age of 18, I acknowledge that this waiver must be signed by my parent or legal guardian.",
  },
  {
    element: "li",
    text: "Physical and Mental Demand Acknowledgment: I understand that SPYGAMES & SPYSCAPE activities are physically and mentally demanding. I affirm that neither I nor any minors named below have medical or physical conditions that would impair our ability to participate or would pose a risk to ourselves or others during the activities.",
  },
  {
    element: "li",
    text: "Acknowledgment of Risk: I acknowledge that participation in activities at SPYGAMES & SPYSCAPE involves inherent risks and hazards and I voluntarily assume all risks associated with these activities, which include potential physical injury or emotional distress.",
  },
  {
    element: "li",
    text: "Explicit Risks: I understand the risks of participation may include physical and/or emotional injury, infectious diseases, and other potential hazards as follows:",
    children: [
      {
        element: "ul",
        className: "list-disc pl-5",
        text: "",
        children: [
          { element: "li", text: "Low light conditions", pdfPrefix: "• " },
          {
            element: "li",
            text: "Uneven, irregular, and slippery surfaces and objects",
            pdfPrefix: "• ",
          },
          {
            element: "li",
            text: "Doors that open suddenly without warning",
            pdfPrefix: "• ",
          },
          {
            element: "li",
            text: "Objects that may be thrown or moved by other participants",
            pdfPrefix: "• ",
          },
          {
            element: "li",
            text: "Protruding objects and set pieces that could cause injury",
            pdfPrefix: "• ",
          },
          {
            element: "li",
            text: "Unusual and unfamiliar room structures",
            pdfPrefix: "• ",
          },
          {
            element: "li",
            text: "Loud sounds, bright and flashing lighting & lasers",
            pdfPrefix: "• ",
          },
        ],
      },
    ],
  },
  {
    element: "li",
    text: "Assumption of Risk: I willingly assume all risks associated with participation in SPYGAMES & SPYSCAPE activities, whether they are known or unknown, inherent, or not inherent for myself and any minors in my party.",
  },
  {
    element: "li",
    text: "Release and Indemnification: I voluntarily agree to release, waive, discharge, hold harmless, defend, and indemnify SPYGAMES & SPYSCAPE and the Released Parties from any and all claims or losses arising from participation in SPYGAMES & SPYSCAPE activities, even if caused by the negligence of the Released Parties, for myself and any minors in my party.",
  },
  {
    element: "li",
    text: "Personal Belongings and Conduct: I accept that SPYGAMES & SPYSCAPE and the Released Parties are not liable for the security of my personal belongings. I acknowledge that inappropriate behavior or impairment due to drugs or alcohol may result in my expulsion from SPYGAMES & SPYSCAPE without refund.",
  },
  {
    element: "li",
    text: "Photography and Video Release: I grant SPYGAMES & SPYSCAPE the irrevocable right to use any photographs or video recordings made during my participation for promotional and advertising purposes without further communication or compensation.",
  },
  {
    element: "li",
    text: "Contact Information: I confirm that the contact information I have provided is accurate and consent to its storage by SPYGAMES & SPYSCAPE for operational purposes.",
  },
  {
    element: "li",
    text: "Emergency Medical Treatment: I authorize SPYGAMES & SPYSCAPE to seek emergency medical treatment for me if needed, and I agree to be financially responsible for any related costs.",
  },
  {
    element: "li",
    text: "Severability: If any part of this agreement is found to be unenforceable, the remaining parts will still be in effect.",
  },
  {
    element: "li",
    text: "Duration of the Agreement: This agreement is valid for all my visits to SPYGAMES & SPYSCAPE from the date signed until one year thereafter.",
  },
  {
    element: "li",
    text: "Understanding and Voluntary Acceptance: I confirm that I have read, understood, and freely signed this agreement. I understand that by clicking the 'I AGREE' button, I am consenting to accept and abide by the terms of this waiver electronically.",
  },
];

const agreementNY = [
  {
    element: "li",
    text: "Arbitration Agreement: I agree that any disputes arising from this agreement or my participation in SPYGAMES & SPYSCAPE activities will be resolved through binding arbitration in New York City, New York.",
  },
  {
    element: "li",
    text: "Governing Law: This agreement is governed by and interpreted according to the laws of the State of New York.",
  },
];

const agreementLondon = [
  {
    element: "li",
    text: "Dispute Resolution: I agree that any disputes arising from this agreement or my participation in SPYGAMES & SPYSCAPE activities will be resolved through binding arbitration in London, United Kingdom, in accordance with the rules of the Chartered Institute of Arbitrators (CIArb) or another suitable arbitration body agreed upon by both parties.",
  },
  {
    element: "li",
    text: "Governing Law: This agreement is governed by and interpreted according to the laws of England and Wales.",
  },
];

export const getWaiverContent = (venueId: number) => {
  let agreement;
  switch (venueId) {
    case NY_HQ_VENUE_ID:
      agreement = agreementNY;
      break;
    case LDN_CG_VENUE_ID:
      agreement = agreementLondon;
      break;
    default:
      agreement = agreementNY;
  }

  const waiverContent = [
    ...WAIVER_CONTENT.slice(0, 11),
    ...agreement,
    ...WAIVER_CONTENT.slice(11),
  ];

  return waiverContent;
};
